"use client";

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModalType = 'info' | 'warning' | 'error' | 'confirm' | 'success';

interface ModalState {
    isOpen: boolean;
    type: ModalType;
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    resolveValue: boolean | null;
    // Internal flag to identify if it's a "promise-based" call or fire-and-forget
    isConfirming: boolean;
}

const initialState: ModalState = {
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    confirmLabel: '确定',
    cancelLabel: '取消',
    resolveValue: null,
    isConfirming: false,
};

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        showModal: (state, action: PayloadAction<{
            type?: ModalType;
            title?: string;
            message: string;
            confirmLabel?: string;
            cancelLabel?: string;
            isConfirming?: boolean;
        }>) => {
            state.isOpen = true;
            state.type = action.payload.type || 'info';
            state.title = action.payload.title || '';
            state.message = action.payload.message;
            state.confirmLabel = action.payload.confirmLabel || '确定';
            state.cancelLabel = action.payload.cancelLabel || '取消';
            state.isConfirming = action.payload.isConfirming || false;
            state.resolveValue = null;
        },
        closeModal: (state, action: PayloadAction<boolean>) => {
            state.isOpen = false;
            state.resolveValue = action.payload;
        },
        resetModal: (state) => {
            return initialState;
        },
    },
});

export const { showModal, closeModal, resetModal } = modalSlice.actions;
export default modalSlice.reducer;
